// utils/newebpay.ts
export function postToNewebpay(args, openInNewTab = false) {
  const {
    actionUrl,
    // 單次
    MerchantID,
    TradeInfo,
    TradeSha,
    Version,
    // 定期
    MerchantID_,
    PostData_,
  } = args || {};

  if (!actionUrl || typeof actionUrl !== "string") {
    console.error("[Newebpay] actionUrl 缺失：", { actionUrl });
    throw new Error("支付初始化失敗（缺少 actionUrl）。");
  }

  const isPeriod = Boolean(MerchantID_ && PostData_);
  const isOnce = Boolean(MerchantID && TradeInfo && TradeSha && Version);

  if (!isPeriod && !isOnce) {
    console.error("[Newebpay] 參數不完整：", { MerchantID, TradeInfo, TradeSha, Version, MerchantID_, PostData_ });
    throw new Error("支付初始化參數不完整。");
  }

  // 端點與參數一致性檢查（避免把 Period 參數丟去 mpg_gateway 之類）
  if (isPeriod && !/\/MPG\/period(\b|\/|$)/i.test(actionUrl)) {
    throw new Error("定期定額參數須送至 /MPG/period 端點。");
  }
  if (isOnce && !/\/MPG\/mpg_gateway(\b|\/|$)/i.test(actionUrl)) {
    throw new Error("一次性付款參數須送至 /MPG/mpg_gateway 端點。");
  }

  const form = document.createElement("form");
  form.method = "POST";
  form.action = actionUrl;
  form.acceptCharset = "UTF-8";
  if (openInNewTab) form.target = "_blank";
  form.style.display = "none";

  const add = (name, value) => {
    const input = document.createElement("input");
    input.type = "hidden";
    input.name = name;
    // 以字串送出，避免 undefined / number 問題
    input.value = value == null ? "" : String(value);
    form.appendChild(input);
  };

  if (isPeriod) {
    add("MerchantID_", MerchantID_);
    add("PostData_", PostData_);
  } else {
    add("MerchantID", MerchantID);
    add("TradeInfo", TradeInfo);
    add("TradeSha", TradeSha);
    add("Version", Version);
  }

  document.body.appendChild(form);
  form.submit();
  setTimeout(() => form.remove(), 1000);
}
